export const state = () => ({
  historyList: []
})

export const mutations = {
  add(state, keyword) {
    console.log('store mutation add', state.historyList);
    if (state.historyList.includes(keyword)) return
    if (state.historyList.length >= 10) {
      state.historyList.splice(0 ,1)
    }
    state.historyList.push(keyword)
    localStorage && localStorage.setItem('searchHistory', JSON.stringify(state.historyList))
  },
  initHistoryList(state) {
    state.historyList = process.client ? JSON.parse(localStorage && localStorage.getItem('searchHistory') || '[]') : []
  },
  removeAll(state, payload) {
    state.historyList = []
    localStorage && localStorage.removeItem('searchHistory')
  },
}
